import { render } from "./TransporterreturnsView.vue?vue&type=template&id=c21aa66c"
import script from "./TransporterreturnsView.vue?vue&type=script&lang=js"
export * from "./TransporterreturnsView.vue?vue&type=script&lang=js"

import "./TransporterreturnsView.vue?vue&type=style&index=0&id=c21aa66c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__